<template>


            <tbody>
                <tr v-for="(row, index) in modelValue"
                 @click="setcurentRow(row, index), lastrowdot=false" 
                 @dblclick="expandRow(row)" 
                 :key="row" 
                 :class="{ 'bg-regularlight' : (row==curentRow) , 'bg-attention' : (row==lastrowd && lastrowdot==true) }" >

                  <td v-if="meta.dataset_id === 2017" class="text-medium-emphasis" @click="$router.push('/taxonpage/'+row.id)" target="_blank"> 
                    <v-btn size="29" variant="outline"  color="regular" @click = "handleClick">
                        <svg-icon type="mdi" :path="mdiArrowExpand"/>
                    </v-btn>
                  </td> 
                  <td v-for="col in meta.columns" :key="col">
                       <base-geo-cell v-bind="{mode:'table', column:col, meta:meta, rowobject:row}" v-model="row[col.fieldname]" />
                  </td>
                </tr>

            </tbody>  

</template>
<script>
import SvgIcon from '@jamescoyle/vue-icon';
import { mdiArrowExpand } from '@mdi/js';
export default {
    name: 'data-table',
    components: {
      SvgIcon,
    },

    data(){ 
        return {
          mdiArrowExpand:mdiArrowExpand,
            curentRow:{},
datameta: this.meta,
        }
    },
    props:['meta','modelValue', 'lastrowd', 'lastrowdot'],
    emits: ['getrow'],
    methods: {

        setcurentRow(row, index) {
//          console.log(row, index);
            this.curentRow = row;
          this.$emit('getrow', this.curentRow, index);
        },

        expandRow(row) {
            this.curentRow = row;
            this.dialogrow = true;
        },
    },

}
</script>